import { createContext, useContext, useEffect, useState } from "react";
import { API } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=unauth, obj=auth

  useEffect(() => {
    // Returning from Google OAuth: AuthCallback exchanges the session_id first.
    if (window.location.hash?.includes("session_id=")) return;
    const token = localStorage.getItem("mb_token");
    if (!token) { setUser(false); return; }
    API.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("mb_token"); setUser(false); });
  }, []);

  const login = async (email, password) => {
    const { data } = await API.post("/auth/login", { email, password });
    localStorage.setItem("mb_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const loginWithSession = async (sessionId) => {
    const { data } = await API.post("/auth/session", { session_id: sessionId }, { withCredentials: true });
    localStorage.setItem("mb_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    API.post("/auth/logout", {}, { withCredentials: true }).catch(() => {});
    localStorage.removeItem("mb_token");
    setUser(false);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, loginWithSession, logout, isAdmin: user?.role === "admin" }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
